<script setup lang="ts">
import type { VirtualBackground } from '~/constants/virtual-background'
import { VIRTUAL_BACKGROUNDS } from '~/constants'

const props = withDefaults(defineProps<{
  modelValue?: VirtualBackground
  options?: VirtualBackground[]
}>(), {
  options: () => VIRTUAL_BACKGROUNDS,
})

const emit = defineEmits(['update:modelValue'])
const value = useVModel(props, 'modelValue', emit)

function onSelect(option: VirtualBackground) {
  emit('update:modelValue', option)
}
</script>

<template>
  <div class="flex flex-wrap gap-4 p-2">
    <div
      v-for="option in options"
      :key="option.src + (option.blurAmount ?? '')"
      :class="[
        {
          'ring-2 ring-primary scale-105':
            value?.src === option.src && value?.blurAmount === option.blurAmount,
        },
      ]"
      class="group relative cursor-pointer border border-$c-accent rounded-lg transition-all duration-200"
      @click="onSelect(option)"
    >
      <div
        v-if="option.type === 'image'"
        class="aspect-video w-32 overflow-hidden rounded-lg"
      >
        <img
          :src="option.src"
          class="h-full w-full object-cover"
          alt="background"
        >
      </div>
      <div
        v-else
        class="aspect-video w-32 flex items-center justify-center rounded-lg bg-gray-100/80 backdrop-blur"
      >
        <div class="text-sm text-gray-700 font-medium">
          {{ option.label || 'No Background' }}
        </div>
      </div>
      <div
        class="absolute inset-0 rounded-lg bg-black/0 transition-colors duration-200 group-hover:bg-black/10"
      />
    </div>
  </div>
</template>
